<template>
  <ImageSelectWrapper
    :allowMultipleSelect="maxImagesLimit > 1"
    :disabled="readOnly"
    @selected="handleImagesSelected"
  >
    <template slot-scope="{ selectFile, isDraggingFile }">
      <slot
        :isDraggingFile="isDraggingFile"
        :removeImage="showDeleteConfirmation"
        :selectFile="selectFile"
        :showImage="showImage"
      />

      <MediaManagerModal
        :initialImages="images"
        :initialSelectedImageIndex="selectedImageIndex"
        :maxImages="maxImagesLimit"
        :open="isModalOpen"
        :readOnly="readOnly"
        @change="handleImagesChange"
        @close="handleModalClose"
      />

      <DeleteConfirmationModal
        :show="isDeleteConfirmationOpen"
        :title="$t('media.delete_confirmation_title')"
        :text="$t('media.delete_confirmation_message')"
        @cancel="isDeleteConfirmationOpen = false"
        @delete="removeSelectedImage"
      />
    </template>
  </ImageSelectWrapper>
</template>

<script>
import ImageSelectWrapper from '@/components/utils/MediaManagementWrapper/ImageSelectWrapper.vue'
import MediaManagerModal from '@/components/utils/MediaManagementWrapper/MediaManager/MediaManager.vue'
import DeleteConfirmationModal from '@/components/Modals/DeleteConfirmationModal.vue'

import mixin from '@/mixins/mixin.vue'

export default {
  mixins: [mixin],

  components: {
    DeleteConfirmationModal,
    ImageSelectWrapper,
    MediaManagerModal,
  },

  props: {
    initialImages: {
      type: Array,
      default: () => [],
    },

    maxImages: Number,

    readOnly: Boolean,
  },

  data() {
    return {
      images: [...this.initialImages],
      isDeleteConfirmationOpen: false,
      isDraggingFile: false,
      isModalOpen: false,
      selectedImageIndex: null,
    }
  },

  computed: {
    maxImagesLimit() {
      return this.maxImages ?? this.$constants.images.defaultLimit
    },
  },

  watch: {
    initialImages(images) {
      this.images = [...images]
    },
  },

  methods: {
    async handleModalClose() {
      this.isModalOpen = false

      await this.$nextTick()

      this.images = [...this.initialImages]
    },

    handleImagesSelected(selectedImages) {
      const nextTotalImages = this.images.length + selectedImages.length

      if (nextTotalImages > this.maxImagesLimit) {
        return this.showError(
          this.$t('media.limit_images_error', {
            maxImages: this.maxImagesLimit,
          })
        )
      }

      this.images = [...this.images, ...selectedImages]
      this.isModalOpen = true
    },

    handleImagesChange(mediaObjects) {
      this.$emit('change', mediaObjects)
      this.isModalOpen = false
    },

    async showImage(index) {
      this.isModalOpen = true
      await this.$nextTick()
      this.selectedImageIndex = index
    },

    showDeleteConfirmation(index) {
      this.selectedImageIndex = index
      this.isDeleteConfirmationOpen = true
    },

    removeSelectedImage() {
      const newImages = [...this.images]
      newImages.splice(this.selectedImageIndex, 1)

      this.$emit('change', newImages)
      this.isDeleteConfirmationOpen = false
    },
  },
}
</script>
